import type { UpdateUserProfile, UserProfile } from '@ditto/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedClient, useProtectedQuery } from './useApi';

export const useUserProfileApi = () => {
  const { client } = useAuthenticatedClient(false);

  return useProtectedQuery({
    queryKey: ['user-profile'],
    queryFn: async () => {
      const response = await client.users.getUserProfile();

      if (response.status === 200) {
        return response.body as UserProfile;
      }
      throw new Error('Failed to fetch user profile');
    },
    retry: 1,
  });
};

export const useUpdateUserProfileApi = () => {
  const { client } = useAuthenticatedClient(false);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updateData: UpdateUserProfile) => {
      const response = await client.users.updateUserProfile({
        body: updateData,
      });

      if (response.status === 200) {
        return response.body as UserProfile;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
    },
  });
};
